import { CheckCircle, AlertCircle, XCircle, Clock } from 'lucide-react';

interface StatusCardProps {
  title: string;
  status: 'healthy' | 'warning' | 'error' | 'unknown';
  details?: Array<{ label: string; value: string | number }>;
}

export function StatusCard({ title, status, details }: StatusCardProps) {
  const statusConfig = {
    healthy: {
      icon: CheckCircle,
      color: 'text-green-500',
      bg: 'bg-green-50',
      border: 'border-green-200',
      label: 'Healthy',
    },
    warning: {
      icon: AlertCircle,
      color: 'text-yellow-500',
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      label: 'Warning',
    },
    error: {
      icon: XCircle,
      color: 'text-red-500',
      bg: 'bg-red-50',
      border: 'border-red-200',
      label: 'Error',
    },
    unknown: {
      icon: Clock,
      color: 'text-gray-500',
      bg: 'bg-gray-50',
      border: 'border-gray-200',
      label: 'Unknown',
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <div
      className={`rounded-xl border ${config.border} ${config.bg} p-4`}
    >
      <div className="flex items-center gap-3">
        <Icon className={config.color} size={24} />
        <div>
          <p className="font-medium text-gray-900">{title}</p>
          <p className={`text-sm ${config.color}`}>{config.label}</p>
        </div>
      </div>

      {details && details.length > 0 && (
        <div className="mt-4 space-y-2">
          {details.map((detail, index) => (
            <div
              key={index}
              className="flex justify-between text-sm"
            >
              <span className="text-gray-600">{detail.label}</span>
              <span className="font-medium text-gray-900">{detail.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
